export const formattedUrl = (production: string, development: string) => {
  if (process.env.NODE_ENV === 'production') {
    return production;
  }
  return development;
};
